import React from 'react'
import Layout from 'components/shared/Layout'
import GradientHeader from 'components/shared/GradientHeader'
import LabelTitleText from 'components/shared/LabelTitleText'
import classnames from 'classnames/bind'
import { getMargin } from 'src/lib/margin'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const Div = ({ wrapperClassName, children }) => (
  <div className={wrapperClassName}>{children}</div>
)

const GradientHeaderWithIntro = ({
  className,
  children,
  headerChildren,
  intro,
  center,
  gradientHeader,
  wrapperClassName,
  fullWidth,
  marginTop,
  marginBottom,
}) => {
  const marginB = getMargin(marginBottom)
  const marginT = getMargin(marginTop)

  const Container = gradientHeader ? GradientHeader : Div

  const renderContent = () => (
    <>
      {intro && (
        <LabelTitleText
          {...intro}
          center={center}
          textProps={{ ...intro.textProps, size: 'big' }}
          className={cx(css.intro, {
            withGradient: gradientHeader,
            alignLeft: !center,
          })}
        />
      )}
      {headerChildren && headerChildren()}
    </>
  )

  return (
    <Layout
      type="maxWidth"
      className={cx(className, css.GradientHeaderWithIntro, { fullWidth })}
      style={{ marginTop: marginT, marginBottom: marginB }}
    >
      <Container
        wrapperClassName={wrapperClassName}
        fullWidth={fullWidth}
        {...gradientHeader}
      >
        {gradientHeader ? (
          renderContent()
        ) : (
          <Layout type="wrapper">{renderContent()}</Layout>
        )}
      </Container>
      {children}
    </Layout>
  )
}

GradientHeaderWithIntro.defaultProps = {
  intro: {},
  center: true,
}

export default GradientHeaderWithIntro
